<div class="d-flex flex-column w-100 m-auto">
  <div class="d-flex flex-wrap flex-sm-nowrap container gap-3">
    <div class="d-flex flex-column col-12 col-sm-6">
      <app-ashgrid-appellation class="mb-0"></app-ashgrid-appellation>

      <div class="d-flex mt-5">
        <app-apple-icon class="w-56px h-56px" [classes]="'w-56px h-56px'"></app-apple-icon>
        <p class="ms-2 my-auto fw-normal" style="font-size: 56px; line-height: normal;">Apple</p>
      </div>
    </div>

    <div class="d-flex flex-column col-12 col-sm-6 mt-3 mt-sm-0 mxw-420px">
      <!-- INFO Headline -->
      <div class="d-flex mx-auto my-auto mb-3 p-2e">
        <p class="my-auto mat-headline-5 fw-bold">Logging you in...</p>
      </div>
    </div>
  </div>
</div>
